import {TokenUtil} from "../../app/utils/Utils";
import {Endpoints} from "../Endpoints";
import {LoginService} from "../services/LoginService";
import {InvalidTokenError, SessionCodeMissingError} from "../../shared-api/exceptions/CustomError";
import {Environment} from "../../shared-api/helpers/Environment";

export class TokenController {
    // 1. Adicionamos o 'verifier' recebido do Hook (pode ser opcional para não quebrar compatibilidade)
    constructor(private code: string, private verifier?: string) {
        if (!code) {
            throw new SessionCodeMissingError();
        }
        this.code = code;
    }

    async hasToken(): Promise<boolean> {
        try {
            let accessToken = TokenUtil.getToken();
            if (!accessToken) {
                
                // 2. Prepara o pacote de dados
                const payload: any = {
                    grant_type: 'authorization_code',
                    client_id: Environment.get("REACT_APP_CLIENT_ID"),
                    // ATENÇÃO: Tem que ser a MESMA variável de redirect que você usou na sua página de Ida!
                    redirect_uri: Endpoints.REDIRECT_CALLBACK_LOGIN, // Ajuste para a variável correta que aponta pro /callback
                    code: this.code,
                };

                // 3. Se o verifier existir (e agora existe), manda a chave pro governo!
                if (this.verifier) {
                    payload.code_verifier = this.verifier;
                }

                // Dispara o POST
                const sessionData = await LoginService.post(Endpoints.TOKEN, payload);

                if (typeof sessionData.access_token !== 'string') {
                    throw new InvalidTokenError();
                }

                accessToken = sessionData.access_token.trim();
                TokenUtil.setToken(accessToken);
            }

            return !!accessToken;
        } catch (error) {
            console.error('[Erro][MTLogin]: ', error); // Sugiro descomentar isso pra ver se der erro 400!
            return false;
        }
    }
}